import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";

export default function initInspiredCarousel() {
  const wrappers = document.querySelectorAll(".inspired-carousel-wrapper");

  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    const swiperContainer = wrapper.querySelector(".swiper");
    const tiles = wrapper.querySelectorAll(".inspired-tile");
    const galleryId = wrapper.dataset.gallery;
    const modal = galleryId ? document.querySelector(galleryId) : null;

    if (!swiperContainer) return;

    const prevButton = wrapper.querySelector(
      ".carousel-controls .carousel-button-prev"
    );
    const nextButton = wrapper.querySelector(
      ".carousel-controls .carousel-button-next"
    );
    const mainProgressBar = wrapper.querySelector(
      ".carousel-controls .carousel-progress-bar"
    );

    function updateMainProgress(swiper) {
      if (!mainProgressBar) return;
      const total = swiper.slides.length;
      const perView =
        typeof swiper.params.slidesPerView === "number"
          ? swiper.params.slidesPerView
          : 1;
      const visible = Math.min(perView / total, 1);
      const scrollProgress = Math.min(Math.max(swiper.progress, 0), 1);
      if (isNaN(scrollProgress)) return;
      const progress = (visible + scrollProgress * (1 - visible)) * 100;
      mainProgressBar.style.width = `${Math.min(progress, 100)}%`;
    }

    // Initialize main carousel
    new Swiper(swiperContainer, {
      modules: [Navigation],
      slidesPerView: 1.2,
      centeredSlides: false,
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      grabCursor: true,
      loop: false,
      observer: true,
      observeParents: true,
      touchEventsTarget: "container",
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      on: {
        init: updateMainProgress,
        slideChange: updateMainProgress,
        progress: updateMainProgress,
        observerUpdate: updateMainProgress,
        resize: updateMainProgress,
      },
      breakpoints: {
        744: {
          slidesPerView: 2.5,
        },
        744: {
          spaceBetween: 24,
          slidesOffsetBefore: 24,
          slidesOffsetAfter: 24,
        },
        1280: {
          slidesPerView: 2.8,
          spaceBetween: 32,
          slidesOffsetBefore: 32,
          slidesOffsetAfter: 32,
        },
      },
    });

    // Lightbox functionality
    if (!modal || !tiles.length) return;

    const modalSwiperContainer = modal.querySelector(".inspired-modal-swiper");
    const modalPrevButton = modal.querySelector(".carousel-button-prev");
    const modalNextButton = modal.querySelector(".carousel-button-next");
    const progressBar = modal.querySelector(".carousel-progress-bar");
    const modalControls = modal.querySelector(".carousel-controls");
    const closeButton = modal.querySelector(".modal-close");

    let modalSwiper = null;

    function fitImageContainers() {
      const slides = modal.querySelectorAll(".inspired-image");
      const modalContent = modal.querySelector(".modal-content");
      if (!modalContent) return;
      const contentStyle = getComputedStyle(modalContent);
      const contentPadding =
        parseFloat(contentStyle.paddingTop) +
        parseFloat(contentStyle.paddingBottom);
      const controlsHeight = modalControls ? modalControls.offsetHeight : 0;
      const swiperMarginTop = 50; // rem-calc(50)
      const maxH =
        window.innerHeight - contentPadding - controlsHeight - swiperMarginTop;
      slides.forEach((container) => {
        const img = container.querySelector("img");
        const iframe = container.querySelector("iframe");
        let natural;
        if (img && img.naturalWidth && img.naturalHeight) {
          natural = img.naturalWidth / img.naturalHeight;
        } else if (iframe) {
          const wAttr = iframe.getAttribute("width") || "";
          const hAttr = iframe.getAttribute("height") || "";
          const iw = wAttr.includes("%") ? NaN : parseFloat(wAttr);
          const ih = hAttr.includes("%") ? NaN : parseFloat(hAttr);
          natural = iw && ih ? iw / ih : 16 / 9;
        } else {
          return;
        }
        const maxW = container.parentElement.clientWidth;
        let w, h;
        if (maxW / maxH > natural) {
          h = maxH;
          w = h * natural;
        } else {
          w = maxW;
          h = w / natural;
        }
        container.style.width = `${w}px`;
        container.style.height = `${h}px`;
      });
    }

    function pauseVideoIframes(root) {
      root.querySelectorAll("iframe").forEach((iframe) => {
        const src = iframe.src;
        if (!src) return;
        if (/youtube\.com|youtu\.be/.test(src)) {
          iframe.contentWindow?.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            "*"
          );
        } else if (/vimeo\.com/.test(src)) {
          iframe.contentWindow?.postMessage('{"method":"pause"}', "*");
        }
      });
    }

function updateProgressBar(swiper) {
      if (!swiper || !progressBar) return;

      // Use realIndex for loop mode (excludes duplicated slides)
      const total = tiles.length;
      const currentIndex = swiper.realIndex + 1;
      const progress = (currentIndex / total) * 100;
      progressBar.style.width = `${progress}%`;
    }

    function updateControlsVisibility(swiper) {
      if (!modalControls) return;
      if (swiper.slides.length <= 1) {
        modalControls.style.display = "none";
      } else {
        modalControls.style.display = "";
      }
    }

    function openModal(slideIndex = 0) {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      document.body.classList.add("modal-open");
      document.body.style.overflow = "hidden";

      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      }

      modal.style.display = "flex";
      setTimeout(() => {
        modal.classList.add("show");
        // Fit containers after modal is visible, and also when images load
        fitImageContainers();
        modal.querySelectorAll(".inspired-image img").forEach((img) => {
          if (!img.complete) {
            img.addEventListener("load", fitImageContainers, { once: true });
          }
        });
      }, 10);

      if (!modalSwiper && modalSwiperContainer) {
        modalSwiper = new Swiper(modalSwiperContainer, {
          modules: [Navigation],
          slidesPerView: 1,
          spaceBetween: 24,
          initialSlide: slideIndex,
          loop: true,
          autoHeight: true,
          navigation: {
            prevEl: modalPrevButton,
            nextEl: modalNextButton,
          },
          on: {
            init: function () {
              updateProgressBar(this);
              updateControlsVisibility(this);
              fitImageContainers();
            },
            slideChange: function () {
              updateProgressBar(this);
              pauseVideoIframes(modal);
            },
            resize: fitImageContainers,
          },
        });
      } else if (modalSwiper) {
        // If swiper already exists, slide to the clicked index (use slideToLoop for loop mode)
        modalSwiper.slideToLoop(slideIndex, 0);
      }
    }

    function closeModal() {
      modal.classList.remove("show");
      pauseVideoIframes(modal);

      setTimeout(() => {
        modal.style.display = "none";
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      }, 150);
    }

    function handleKeydown(e) {
      if (e.key === "Escape" && modal.classList.contains("show")) {
        closeModal();
      }
    }

    // Click handler for each tile (only if not dragging)
    let isDragging = false;
    swiperContainer.addEventListener("pointerdown", () => {
      isDragging = false;
    });
    swiperContainer.addEventListener("pointermove", () => {
      isDragging = true;
    });
    tiles.forEach((tile, index) => {
      tile.addEventListener("click", (e) => {
        e.preventDefault();
        if (!isDragging) openModal(index);
      });
    });

    if (closeButton) {
      closeButton.addEventListener("click", closeModal);
    }

    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        closeModal();
      }
    });

    document.addEventListener("keydown", handleKeydown);
  });
}
